export default {
  heading: {
    title:
      "<span>It’s me.</span> Colleague, friend, child, sibling, partner. <span>Person.</span>",
    subtitle: "LGBTQ+ affirming resources and support",
    description:
      "Do you or someone you care about in the LGBTQ+ community need support for a mental health or substance use concern? The following are some LGBTQ+ affirming resources to help you get started.",
    pdf: "/assets/pdf/P365+_LGBTQ+_Resource_Guide.pdf",
  },
  crisis: "Crisis hotlines and text",
  crisisDescription:
    "If you are in immediate danger or have a medical emergency, call 911.\n\nIf you are in crisis or thinking about suicide, call 988 immediately.",
  trevorLogo: require("@assets/images/toolkits/trevor_logo.png"),
  trevorLabel:
    "The Trevor Project has several direct online resources specifically for LGBTQ+ youth:",
  trevorHotlines: [
    {
      title: "Trevor Lifeline",
      description:
        'A crisis intervention and suicide prevention phone service available 24/7 at <a href="tel:+1-866-488-7386"> 1-866-488-7386</a>.',
    },
    {
      title: "TrevorChat",
      description:
        'A confidential online instant messaging with a Trevor Counselor, available 24/7, at <a href="https://www.thetrevorproject.org/get-help/">trevorproject.org/get-help-now/</a>.',
    },
    {
      title: "TrevorText",
      description:
        'A confidential text messaging with a Trevor Counselor, available 24/7/365, by texting START to <a href="tel:+678678">678678.</a>',
    },
    {
      title: "TrevorSpace",
      description:
        'An affirming international community for LGBTQ+ young people ages 13-24 available at <a href="https://www.trevorspace.org/">trevorspace.org.</a>',
    },
  ],
  trevorLifeline:
    "<strong>Trans Lifeline Hotline</strong> is a peer support service run by trans people located all over the US and Canada, for trans and questioning callers.",
  trevorLinks:
    'You can call <strong>Trans Lifeline Hotline</strong> at <a href="tel:+877-565-8860">877-565-8860</a> <a href="https://translifeline.org/hotline/">translifeline.org/hotline</a>',
  crisisHotlines: [
    {
      img: require("@assets/images/toolkits/hotline1.png"),
      label: "SAGE National LGBT Elder Hotline",
      number: '<a href="tel:+1-877-360-5428">1-877-360-LGBT (5428)</a>',
    },
    {
      img: require("@assets/images/toolkits/hotline2.png"),
      label: "988 Suicide & Crisis Prevention Lifeline",
      number:
        'Call or text <a href="tel:988">988</a>\nor chat online:\n<a ref="https://988lifeline.org/get-help/">Get Help - 988 Lifeline</a>',
    },
    {
      img: require("@assets/images/toolkits/hotline3.png"),
      label: "National Domestic Violence Hotline",
      number:
        '<a href="tel:+1-800-799-7233">1-800-799-7233 (SAFE)</a>\nText START to 88788',
    },
  ],
  rainLogo: require("@assets/images/toolkits/rainn.png"),
  rainLabel: "National Sexual Assault Hotline",
  rainNumber:
    '<a href="tel:+1-800-656-4673"> 1-800-656-4673</a> (HOPE)\n<a href="https://hotline.rainn.org/online" target="_blank">Online Chat</a>',
  mental: "Mental health and community resources",
  mentalSources: [
    {
      label: "Association of Gay and Lesbian Psychiatrists",
      sublabel:
        " – Provides mental health resources for LGBTQ+ individuals, including psychiatric professionals with LGBTQ+ clients.",
      link: "https://www.aglp.org/",
    },
    {
      label: "American Psychological Association (APA)",
      sublabel: " – Provides educational and support resources.",
      link: "https://www.apa.org/pi/lgbt/resources/lgbt-health",
    },
    {
      label: "Black Mental Health Alliance (BMHA)",
      sublabel:
        " – Through an expansive database of culturally competent and patient-centered licensed mental health professionals, BMHA offers confidential referrals for those seeking mental health services.",
      link: "https://blackmentalhealth.com/connect-with-a-therapist/",
    },
    {
      label: "CenterLink LGBT Community Center Member Directory",
      sublabel:
        " – Supports the development of strong, sustainable, LGBTQ community centers to address social, cultural, health, and political advocacy.",
      link: "https://www.lgbtcenters.org/lgbtcenters",
    },
    {
      label: "Gay and Lesbian Medical Association’s Provider Directory",
      sublabel:
        " – A search tool that can locate LGBTQ+-inclusive health care providers.",
      link: "https://www.glma.org/find_a_provider.php",
    },
    {
      label: "LGBT National Help Center",
      sublabel:
        " – Offers confidential peer support connections for LGBTQ+ youth, adults and seniors, including phone, text and online chat.",
      link: "http://lgbtnationalhelpcenter.org/",
    },
    {
      label: "National Queer and Trans Therapists of Color Network",
      sublabel:
        " — Provides a directory to help queer and trans people of color locate mental health providers who are queer and trans people of color.",
      link: `https://d.docs.live.net/184a8a9fe7f40b9d/Ani's stuff 041824/Freelance 041824/OPT/Project_EWS Pride - Lindsey Mar 25/Home - National Queer and Trans Therapists of Color Network`,
    },
    {
      label: "Advocates for Trans  Equality",
      sublabel:
        " – Offers resources for transgender individuals, including information on access to health care.",
      link: "https://transequality.org/",
    },
    {
      label: "OutCare Health",
      sublabel:
        " – Provides comprehensive resources, support and education, including a directory of LGBTQ+ affirming healthcare providers.",
      link: "https://www.outcarehealth.org/",
    },
    {
      label: "SAGE Advocacy & Services for LGBTQ+ Elders",
      sublabel:
        " – Provides information about community support resources, such as healthcare, transportation, counseling, legal services and emotional support programs.",
      link: "https://www.sageusa.org/what-we-do/sage-national-lgbt-elder-hotline/",
    },
    {
      label:
        "Society for Sexual, Affectional, Intersex, and Gender Expansive Identities (SAIGE)",
      sublabel:
        " – Offers educational and support resources for LGBTQ+ individuals, and promotes LGBTQ+ competency for counseling professionals.",
      link: "https://saigecounseling.org/",
    },
    {
      label: "Trans Lifeline",
      sublabel: " – Provides trans peer support: 1-877-565-8860.",
      link: "https://translifeline.org/",
    },
  ],
};
